import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { transition1 } from "../transitions";

// 🖼️ صور الأعمال
import altbau from "../assets/img/altbau.jpg";
import renovierung from "../assets/img/renovierung.jpg";
import malen from "../assets/img/malen.jpg";
import fliesen from "../assets/img/fliesen.jpg";
import elektro from "../assets/img/elektro.jpg";
import holz from "../assets/img/holz.jpg";
import boden from "../assets/img/boden.jpg";
import kueche from "../assets/img/küche.jpg";
import umzug from "../assets/img/umzug.png";
import bade from "../assets/img/bade/bade.jpg";
import küche from "../assets/img/küche/küche.jpg";
import zimmer1 from "../assets/img/zimmer/zimmer1.jpg";
import zimmer2 from "../assets/img/zimmer/zimmer2.jpg";

const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { ...transition1, delay } },
});

const Projekte = () => {
  useEffect(() => {
    document.title = "Unsere Projekte";
  }, []);

  // 🔄 صور الكاروسيل
  const galleryImages = [bade, küche, zimmer1, zimmer2];
  const [currentIndex, setCurrentIndex] = useState(0);

  // ⏱️ تحريك تلقائي كل 7 ثوانٍ
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [galleryImages.length]);

  return (
    <motion.div
      className="min-h-screen bg-gray-50 overflow-x-hidden"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 40 }}
      transition={transition1}
    >
      <div className="container mx-auto px-4 mt-24 sm:px-6 lg:px-8 py-12 sm:py-16 text-[#103d5b]" lang="de">
        {/* ================= HEADER ================= */}
        <motion.div variants={fadeUp(0.1)} initial="hidden" animate="show" className="text-center mb-12">
          <h1 className="font-extrabold text-3xl sm:text-4xl md:text-5xl mb-4">Unsere Projekte & Leistungen</h1>
          <p className="max-w-3xl mx-auto text-lg sm:text-xl leading-relaxed">
            Die <strong>YOUKA GmbH</strong> realisiert vielfältige Bauprojekte mit Leidenschaft, Präzision und
            langjähriger Erfahrung. Von der Altbausanierung bis zu modernen Innenausbauten – wir bieten
            ganzheitliche Lösungen aus einer Hand.
          </p>
        </motion.div>
        <br></br>
        <br></br>
        {/* ================= SECTIONS ================= */}
        <div className="space-y-20">

          {/* 0 */}
          <motion.div variants={fadeUp(0.3)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center md:flex-row-reverse">
            <div>
              <h2 className="text-3xl font-bold mb-4">Umzüge & Haushaltsauflösungen</h2>
              <p className="text-lg leading-relaxed">
                Ob Wohnung, Haus oder Büro – wir transportieren Ihr Mobiliar sicher und termingerecht.
                Unser Team übernimmt Verpacken, Tragen, Demontage/Montage, Entsorgung und die vollständige Entrümpelung
                inklusive umweltgerechter Verwertung.
              </p>
            </div>
            <img src={umzug} alt="Umzug und Haushaltsauflösung" className="rounded-2xl shadow-2xl w-full object-cover" />
          </motion.div>


          {/* 1 */}
          <motion.div variants={fadeUp(0.2)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center">
            <img src={altbau} alt="Altbausanierung" className="rounded-2xl shadow-2xl w-full object-cover" />
            <div>
              <h2 className="text-3xl font-bold mb-4">Altbausanierung & Entkernung</h2>
              <p className="text-lg leading-relaxed">
                Wir übernehmen die fachgerechte Entkernung alter Gebäude, inklusive Rückbau, Entsorgung und Vorbereitung
                für die Sanierung. Unser Ziel ist es, historische Substanz zu bewahren und zugleich moderne Standards zu integrieren.
              </p>
            </div>
          </motion.div>

          {/* 2 */}
          <motion.div variants={fadeUp(0.3)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center md:flex-row-reverse">
            <div>
              <h2 className="text-3xl font-bold mb-4">Renovierungen & Modernisierungen</h2>
              <p className="text-lg leading-relaxed">
                Ob Wohnung, Haus oder Büro – wir bringen Räume auf den neuesten Stand. Unsere Arbeiten reichen von
                Trockenbau über Wandgestaltung bis hin zu Bodenbelägen und neuen Installationen.
              </p>
            </div>
            <img src={renovierung} alt="Renovierung" className="rounded-2xl shadow-2xl w-full object-cover" />
          </motion.div>

          {/* 3 */}
          <motion.div variants={fadeUp(0.4)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center">
            <img src={malen} alt="Malerarbeiten" className="rounded-2xl shadow-2xl w-full object-cover" />
            <div>
              <h2 className="text-3xl font-bold mb-4">Maler- & Spachtelarbeiten</h2>
              <p className="text-lg leading-relaxed">
                Mit hochwertigen Farben und professioneller Technik sorgen wir für perfekte Oberflächen – von
                klassischen Anstrichen bis zu modernen Wanddesigns.
              </p>
            </div>
          </motion.div>

          {/* 4 */}
          <motion.div variants={fadeUp(0.5)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center md:flex-row-reverse">
            <div>
              <h2 className="text-3xl font-bold mb-4">Fliesen-, Sanitär- & Küchenarbeiten</h2>
              <p className="text-lg leading-relaxed">
                Wir verlegen hochwertige Fliesen, erneuern Bäder und installieren Küchenanschlüsse präzise und langlebig.
                Funktionalität trifft hier auf modernes Design.
              </p>
            </div>
            <img src={fliesen} alt="Fliesenarbeiten" className="rounded-2xl shadow-2xl w-full object-cover" />
          </motion.div>

          {/* 5 */}
          <motion.div variants={fadeUp(0.6)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center">
            <img src={elektro} alt="Elektroinstallation" className="rounded-2xl shadow-2xl w-full object-cover" />
            <div>
              <h2 className="text-3xl font-bold mb-4">Elektroinstallationen & Beleuchtung</h2>
              <p className="text-lg leading-relaxed">
                Vom Neuanschluss bis zur kompletten Elektroplanung – wir kümmern uns um sichere Stromversorgung und moderne Beleuchtungssysteme.
              </p>
            </div>
          </motion.div>

          {/* 6 */}
          <motion.div variants={fadeUp(0.7)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center md:flex-row-reverse">
            <div>
              <h2 className="text-3xl font-bold mb-4">Holz-, Türen- & Fensterarbeiten</h2>
              <p className="text-lg leading-relaxed">
                Maßgeschneiderte Türen, Fenster und Holzelemente verleihen jedem Raum Charakter – gefertigt mit Präzision und Liebe zum Detail.
              </p>
            </div>
            <img src={holz} alt="Holzarbeiten" className="rounded-2xl shadow-2xl w-full object-cover" />
          </motion.div>

          {/* 7 */}
          <motion.div variants={fadeUp(0.8)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center">
            <img src={boden} alt="Bodenbeläge" className="rounded-2xl shadow-2xl w-full object-cover" />
            <div>
              <h2 className="text-3xl font-bold mb-4">Bodenbeläge & Parkett</h2>
              <p className="text-lg leading-relaxed">
                Ob Fliesen, Laminat oder Parkett – wir verlegen Böden präzise, langlebig und optisch perfekt.
              </p>
            </div>
          </motion.div>

          {/* 8 */}
          <motion.div variants={fadeUp(0.9)} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-12 items-center md:flex-row-reverse">
            <div>
              <h2 className="text-3xl font-bold mb-4">Küchen & Innenausbau</h2>
              <p className="text-lg leading-relaxed">
                Wir gestalten individuelle Küchen und Innenräume mit hochwertigen Materialien und durchdachtem Design.
              </p>
            </div>
            <img src={kueche} alt="Küchenbau" className="rounded-2xl shadow-2xl w-full object-cover" />
          </motion.div>
        </div>

        {/* ================= IMAGE CAROUSEL ================= */}
        <motion.div
          variants={fadeUp(1.1)}
          initial="hidden"
          animate="show"
          className="mt-28 bg-white rounded-2xl shadow-xl py-10 relative overflow-hidden"
        >
          <h3 className="text-center text-3xl font-bold mb-10">Einblick in unsere Arbeit</h3>

          <div className="relative w-full max-w-5xl mx-auto overflow-hidden rounded-xl">
            <motion.img
              key={currentIndex}
              src={galleryImages[currentIndex]}
              alt="Projektbild"
              className="w-full h-[500px] object-cover rounded-xl transition-all duration-700 ease-in-out"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />

            {/* أزرار التحكم */}
            <button
              onClick={() =>
                setCurrentIndex((prev) =>
                  prev === 0 ? galleryImages.length - 1 : prev - 1
                )
              }
              className="absolute top-1/2 left-4 -translate-y-1/2 bg-gray-900 bg-opacity-50 text-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-opacity-75 transition"
            >
              ‹
            </button>
            <button
              onClick={() =>
                setCurrentIndex((prev) => (prev + 1) % galleryImages.length)
              }
              className="absolute top-1/2 right-4 -translate-y-1/2 bg-gray-900 bg-opacity-50 text-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-opacity-75 transition"
            >
              ›
            </button>
          </div>

          {/* نقاط التنقل الصغيرة */}
          <div className="flex justify-center mt-6 space-x-2">
            {galleryImages.map((_, i) => (
              <div
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`w-3 h-3 rounded-full cursor-pointer transition ${
                  i === currentIndex ? "bg-[#103d5b]" : "bg-gray-300"
                }`}
              ></div>
            ))}
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Projekte;
